var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.28 18C17.1 18 16.92 17.91 16.83 17.82L11.34 12.33C10.08 13.32 8.55 13.86 6.93 13.86C3.15 13.86 0 10.71 0 6.93C0 3.15 3.15 0 6.93 0C10.71 0 13.86 3.15 13.86 6.93C13.86 8.55 13.32 10.08 12.33 11.34L17.82 16.83C18.09 17.1 18.09 17.55 17.82 17.82C17.64 17.91 17.46 18 17.28 18ZM6.93 1.35C3.87 1.35 1.35 3.87 1.35 6.93C1.35 9.99 3.87 12.51 6.93 12.51C8.37 12.51 9.81 11.97 10.89 10.89C11.97 9.81 12.51 8.46 12.51 6.93C12.42 3.87 9.99 1.35 6.93 1.35Z",
    fill: "#83899B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.c484137675577773ec12dad4cdc72be7.svg";
export { ForwardRef as ReactComponent };